/**
 * Heavenly Beds mega menu (snippets/hb-mega-menu.liquid).
 *
 * Desktop (>= 769px, the theme's "md" breakpoint): items with a panel open on hover (with a small
 * intent delay) or on click/tap; only one panel open at a time; Escape or clicking outside closes.
 * Mobile: the <details> elements work as a plain accordion inside the theme's burger drawer.
 */
if (!customElements.get('hb-mega-menu')) {
  class HbMegaMenu extends HTMLElement {
    connectedCallback() {
      this.desktop = window.matchMedia('(min-width: 769px)');
      this.items = Array.from(this.querySelectorAll('.hb-menu__details'));
      this.openTimer = null;
      this.closeTimer = null;

      this.items.forEach((details) => {
        const li = details.closest('.hb-menu__item');
        const summary = details.querySelector('summary');

        li.addEventListener('mouseenter', () => {
          if (!this.isDesktop() || !this.hasHover()) return;
          clearTimeout(this.closeTimer);
          clearTimeout(this.openTimer);
          this.openTimer = setTimeout(() => this.openOnly(details), 120);
        });

        li.addEventListener('mouseleave', () => {
          if (!this.isDesktop() || !this.hasHover()) return;
          clearTimeout(this.openTimer);
          this.closeTimer = setTimeout(() => this.closeAll(), 200);
        });

        summary.addEventListener('click', (evt) => {
          if (!this.isDesktop()) return; // mobile: native accordion
          evt.preventDefault();
          if (details.open) this.closeAll();
          else this.openOnly(details);
        });
      });

      this.onKeyup = (evt) => {
        if (evt.key === 'Escape') this.closeAll();
      };
      this.onDocClick = (evt) => {
        if (this.isDesktop() && !this.contains(evt.target)) this.closeAll();
      };
      this.onBreakpoint = () => this.closeAll();

      // Close when the page scrolls a little (the sticky header slides the menu bar away)
      this.lastScrollY = window.scrollY;
      this.onScroll = () => {
        if (this.classList.contains('is-open') && Math.abs(window.scrollY - this.lastScrollY) > 80) this.closeAll();
        if (!this.classList.contains('is-open')) this.lastScrollY = window.scrollY;
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });

      document.addEventListener('keyup', this.onKeyup);
      document.addEventListener('click', this.onDocClick);
      this.desktop.addEventListener('change', this.onBreakpoint);
    }

    disconnectedCallback() {
      document.removeEventListener('keyup', this.onKeyup);
      window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('click', this.onDocClick);
      this.desktop.removeEventListener('change', this.onBreakpoint);
    }

    isDesktop() {
      return this.desktop.matches;
    }

    hasHover() {
      return window.matchMedia('(hover: hover)').matches;
    }

    openOnly(details) {
      this.items.forEach((d) => {
        if (d !== details) d.open = false;
      });
      details.open = true;
      this.classList.add('is-open');
      this.lastScrollY = window.scrollY;
    }

    closeAll() {
      this.items.forEach((d) => {
        d.open = false;
      });
      this.classList.remove('is-open');
    }
  }

  customElements.define('hb-mega-menu', HbMegaMenu);
}
